import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type {
  LocationLogEntryMinimalReadOnlyRead,
  SignatureRead,
  TripMessageRead,
} from 'src/common/external/bambi-api/bambiApi';
import type {
  TripCreateRead,
  TripEventRead,
  TripUpdateRead,
} from 'src/common/external/bambi-api/tripsApi';

export interface ITripSummaryState {
  currentTripSummaryId?: string;
  tripEvents: TripEventRead[];
  tripCreateEvents: TripCreateRead[];
  tripUpdateEvents: TripUpdateRead[];
  tripLocations: LocationLogEntryMinimalReadOnlyRead[];
  tripMessages: TripMessageRead[];
  tripSignatures: SignatureRead[];
}

export const initialState: ITripSummaryState = {
  tripEvents: [],
  tripCreateEvents: [],
  tripUpdateEvents: [],
  tripLocations: [],
  tripMessages: [],
  tripSignatures: [],
};

export const tripSummarySlice = createSlice({
  name: 'tripSummary',
  initialState,
  reducers: {
    toggleTripSummarySelection: (state, action: PayloadAction<string>) => {
      if (state.currentTripSummaryId === action.payload) {
        state.currentTripSummaryId = undefined;
      } else {
        state.currentTripSummaryId = action.payload;
      }
    },
    loadTripEvents: (state, action: PayloadAction<TripEventRead[]>) => {
      state.tripEvents = action.payload;
    },
    loadTripCreateEvents: (state, action: PayloadAction<TripCreateRead[]>) => {
      state.tripCreateEvents = action.payload;
    },
    loadTripUpdateEvents: (state, action: PayloadAction<TripUpdateRead[]>) => {
      state.tripUpdateEvents = action.payload;
    },
    loadTripLocations: (
      state,
      action: PayloadAction<LocationLogEntryMinimalReadOnlyRead[]>
    ) => {
      state.tripLocations = action.payload;
    },
    loadTripMessages: (state, action: PayloadAction<TripMessageRead[]>) => {
      state.tripMessages = action.payload;
    },
    loadTripSignatures: (state, action: PayloadAction<SignatureRead[]>) => {
      state.tripSignatures = action.payload;
    },
    onLeaveSummary: () => {
      return {
        ...initialState,
      };
    },
  },
});
